import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden pt-20 md:pt-24">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6ae8aed8579cb723d360055be66d76c0.jpg"
          alt="Equipo profesional JUSTCLEAN"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="max-w-4xl">
          <span className="text-sm font-semibold text-primary uppercase tracking-wide">Sobre nosotros</span>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mt-4 mb-6 leading-tight">
            Expertos en vaciado y limpieza en Castelldefels
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            Más de 15 años ofreciendo servicios profesionales de vaciado de pisos, locales y limpieza extrema con total discreción y garantía
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/servicios"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-4 bg-primary text-white rounded-lg font-semibold text-base sm:text-lg hover:bg-primary-dark hover:shadow-glow transition-all cursor-pointer whitespace-nowrap"
            >
              Ver servicios
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/contacto"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-4 border-2 border-white text-white rounded-lg font-semibold text-base sm:text-lg hover:bg-white hover:text-graphite transition-all cursor-pointer whitespace-nowrap"
            >
              Presupuesto
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
